import React from 'react';
import Success from './Success';

export default () => <Success title="Accounts already linked" />;
